module.exports = __webpack_public_path__ + "img/jon_smith_3.8f7920c3.png";